import { authState } from '../../lib/auth.js';
import { getBackendUrl } from '../../lib/backend.js';
import { BaseComponent } from '../../lib/base-component.js';
import { navigateAfterSignIn, SIGN_IN_PATH } from '../../lib/pending-oauth.js';
import { router } from '../../lib/router.js';
import { css, html } from '../../vendor/lit.min.js';

class VerifyView extends BaseComponent {
    static properties = {
        error: { type: String, state: true },
    };

    static styles = css`
        :host { display: block; }
        .verify-card { max-width: 420px; margin: 0 auto; }
    `;

    constructor() {
        super();
        this.error = '';
    }

    async connectedCallback() {
        super.connectedCallback();
        this._verify();
    }

    async _verify() {
        const query = router.getQuery();
        const token = query.get('token');

        if (!token) {
            this.error = 'No token provided';
            return;
        }

        try {
            const response = await fetch(
                `${getBackendUrl()}/api/v1/verify-token?token=${encodeURIComponent(token)}`,
            );
            const data = await response.json();

            if (!response.ok) {
                this.error = data.message || 'Invalid or expired link';
                return;
            }

            authState.setTokens(data.tokens);
            authState.user = data.user;
            authState.isAuthenticated = true;
            authState.notify();
            navigateAfterSignIn(sessionStorage, authState.consentsOutstanding);
        } catch (err) {
            this.error = err.message;
        }
    }

    render() {
        if (this.error) {
            return html`
                <div class="verify-card mt-5">
                    <div class="card shadow">
                        <div class="card-body p-4 text-center">
                            <p class="text-danger">${this.error}</p>
                            <a href="${SIGN_IN_PATH}" class="btn btn-outline-primary mt-3">Back to Sign In</a>
                        </div>
                    </div>
                </div>
            `;
        }

        return html`
            <div class="verify-card mt-5">
                <div class="card shadow">
                    <div class="card-body p-4 text-center">
                        <div class="spinner-border text-primary" role="status"></div>
                        <p class="mt-3 text-muted">Signing you in...</p>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('verify-view', VerifyView);
export { VerifyView };
